import axios from 'axios'
import Cookies from 'universal-cookie'
import { find } from 'lodash'
import BaseURL from './baseURL'
const instance = axios.create({
  timeout: 60000,
  withCredentials: true
})

instance.interceptors.request.use(
  function (config) {
    const cookies = new Cookies()
    const permission = JSON.parse(sessionStorage.getItem('Permission'))
    let currentMenu = cookies.get('currentMenu')

    if (process.env.REACT_APP_API_TOKEN) config.headers['Authorization'] = `Bearer ${process.env.REACT_APP_API_TOKEN}`

    if (currentMenu) {
      let splitMenu = currentMenu?.split('/')
      let menuGroup = splitMenu?.[2]
      let menuName = splitMenu?.[3]
      let currentMenuObj = find(permission, (item) => item.Category === menuGroup && item.MenuName === menuName)
      config.headers['currentMenu'] = currentMenuObj?.MenuID
    }
    return config
  },
  function (error) {
    Promise.reject(error)
  }
)

function timeout(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

function getURLName(originalRequest) {
  let apiURL = originalRequest?.url?.split('/')
  return apiURL?.[apiURL?.length - 1] || ''
}

instance.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    const cookies = new Cookies()
    const originalRequest = error?.config
    let apiName = getURLName(originalRequest)
    let reCallApi = cookies.get(apiName) || 0

    if (error?.response?.status === 401) {
      try {
        if (originalRequest !== null && originalRequest !== undefined && !originalRequest?._retry) {
          originalRequest._retry = true
          const result = await axios.get(BaseURL.appURL() + `/auth/refresh`, { timeout: 60000, withCredentials: true })
          if (result.status === 200) return instance(originalRequest)
        } else {
          return window.location.replace('#/Session-Expire')
        }
      } catch (err) {
        return window.location.replace('#/Session-Expire')
      }
    }

    if (error?.response?.status === 503 && reCallApi < 10) {
      let count = parseInt(reCallApi) + 1
      await timeout(10000)
      cookies.set(apiName, count)
      return instance(originalRequest)
    }

    cookies.remove(apiName)
    // return Error object with Promise
    return Promise.reject(error)
  }
)

export default instance
